function formatConsentList(apiArray: reservationData[], isMobile: boolean) {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  return apiArray.map((item) => {
    const checkInDate = new Date(item.check_in);
    const checkOutDate = new Date(item.check_out);

    const inDate = checkInDate.getDate();
    const outDate = checkOutDate.getDate();

    const inMonth = monthNames[checkInDate.getMonth()];
    const outMonth = monthNames[checkOutDate.getMonth()];
    const inYear = checkInDate.getFullYear();
    const outYear = checkOutDate.getFullYear();

    const range = `${String(inDate).padStart(2, "0")} – ${String(
      outDate,
    ).padStart(2, "0")}`;

    let month: string;
    if (inYear === outYear) {
      month =
        inMonth === outMonth
          ? `${inMonth}, ${inYear}`
          : `${inMonth}–${outMonth}, ${inYear}`;
    } else {
      month = `${inMonth}, ${inYear}–${outMonth}, ${outYear}`;
    }

    if (isMobile) {
      return {
        title: item.property_name,
        location: item.location,
        range,
        month,
      };
    } else {
      return {
        title: item.property_name,
        location: item.location,
        checkIn: {
          date: `${inDate} ${inMonth}`,
          day: dayNames[checkInDate.getDay()],
        },
        checkOut: {
          date: `${outDate} ${outMonth}`,
          day: dayNames[checkOutDate.getDay()],
        },
      };
    }
  });
}

export { formatConsentList };
export type MobileConsentItem = {
  title: string;
  location: string;
  range: string;
  month: string;
};

export type DesktopConsentItem = {
  title: string;
  location: string;
  checkIn: {
    date: string;
    day: string;
  };
  checkOut: {
    date: string;
    day: string;
  };
};
